import { type ComponentType, useEffect, useState } from 'react';
import { onIncomingCallEvent } from '../../../platform/events.ts';
import { RetryBoundary } from '../../../ui/RetryBoundary.tsx';
import { applyIncoming, type IncomingEntry, resetIncoming, useIncomingCall } from './live.ts';

type WindowComponent = ComponentType<{ entry: IncomingEntry }>;

/**
 * Підписка на вхідні дзвінки в оболонці. Чанк вікна — на першому дзвінку, а не в першому екрані
 * (CALL-10, web-calls.md, розд. 7): поки його немає, на екрані й нема чого показувати, а збій
 * завантаження повторить наступний дзвінок.
 */
export function IncomingCallHost() {
  const entry = useIncomingCall();
  const call = entry?.call;
  const [IncomingCallWindow, setWindow] = useState<WindowComponent | null>(null);
  useEffect(() => {
    const off = onIncomingCallEvent(applyIncoming);
    return () => {
      off();
      resetIncoming();
    };
  }, []);
  useEffect(() => {
    if (!call || IncomingCallWindow) return;
    import('./IncomingCallWindow.tsx').then(
      (chunk) => setWindow(() => chunk.default),
      () => {},
    );
  }, [call, IncomingCallWindow]);
  if (!entry || !IncomingCallWindow) return null;
  return (
    <RetryBoundary fallback={() => null}>
      <IncomingCallWindow key={entry.call} entry={entry} />
    </RetryBoundary>
  );
}
